import axios from 'axios';

const api = axios.create({
    baseURL: 'https://painel.recreiodapraia.com.br/api',
})

export default api;